import { render, staticRenderFns } from "./MuiButton.vue?vue&type=template&id=37f2a268&scoped=true"
import script from "./MuiButton.vue?vue&type=script&lang=js"
export * from "./MuiButton.vue?vue&type=script&lang=js"
import style0 from "./MuiButton.vue?vue&type=style&index=0&id=37f2a268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f2a268",
  null
  
)

export default component.exports